import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CourseEditor } from "@/features/courses/components/authoring/course-editor";
// AUTONOMY: per-course settings (module kinds, grading scale, live provider, media).
import { CourseSettingsPanel } from "@/features/academy/components/course-settings-panel";

function AuthoringCoursePage() {
  const params = useParams({ from: "/_app/authoring/$courseId" });
  return (
    <>
      <CourseEditor courseId={params().courseId} />
      <div class="mx-auto max-w-5xl px-4 pb-8">
        <CourseSettingsPanel courseId={params().courseId} />
      </div>
    </>
  );
}

export const authoringCourseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/authoring/$courseId",
  component: AuthoringCoursePage,
});
